<div class="neighborhood-svg-container" [svgInjector]="neighborhood.FullSvgUrl" (svgLoad)="onSvgLoad($event)"
     [style.background-image]="neighborhood.FullBackgroundImageUrl | safeBackgroundImageUrl"></div>
<div class="lot-preview svg-container" #svgContainer></div>